import { useEffect } from 'react'
import { useShortcutsContext } from '../components/KeyboardShortcuts/Shortcuts.context'
import { isAuthenticated } from '../util/authentication'
import { ShortcutsCategories, ShortcutType } from '../components/KeyboardShortcuts/Shortcuts.types'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

const useShortcuts = (category: ShortcutsCategories, shortcuts: ShortcutType, registerFlag=true) => {
    const { registerCategory, unregisterCategory } = useShortcutsContext()
    const authenticated = isAuthenticated()
    const isMobile = useSelector((state: RootState) => state.deviceStore?.isMobile)
    const shouldRegister = registerFlag && !isMobile

    useEffect(() => {
        if (shouldRegister) {
            if (authenticated) registerCategory(category, shortcuts)
            return () => {
                unregisterCategory(category)
            }
        }
    }, [category, shortcuts, registerCategory, unregisterCategory, authenticated, shouldRegister])
}

export default useShortcuts